
<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <!-- <div v-for="(obj,formIndex) in show_data" :key="formIndex" class>
        <div class="d-flex align-items-center mb-4">
          <div>
            LOD_ID :
            <span class="mx-2">{{obj.FormFields[0].form_log_id}}</span>
          </div>
          <div class>
            <button @click="redirect(obj.FormFields[0].form_log_id)" class="btn-blue">Show Details</button>
          </div>
        </div>
      </div>-->
      <!-- <div class="d-flex">
          <div>Data Exists :<span class="ml-2">
            
            <span v-for="(field,fieldKey) in form_data" :key="fieldKey">
            <span v-for="(ffield,ffieldKey) in field" :key="ffieldKey">
              <span>{{ffield.form_field_name}}: {{ffield.field_data=="true"?"YES":ffield.field_data=="undefined"?"NO":ffield.field_data}}</span>
            </span>
          </span>
      
      </span></div>
      </div>-->

      <table class="list-view-table">
        <thead>
          <tr>
            <th>LOG ID</th>
            <th class="text-right">
              <span class="pr-5">View Details</span>
            </th>
          </tr>
        </thead>
        <tbody v-for="(obj,formIndex) in show_data" :key="formIndex">
          <tr>
            <td>{{obj.FormFields[0].form_log_id}}</td>
            <td class="text-right">
              <button @click="redirect(obj.FormFields[0].form_log_id)" class="btn-blue">Show Details</button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- <div>
    <div class="mb-4" v-for="(obj,formIndex) in show_data" :key="formIndex">
      LOG_ID : {{obj.FormFields[0].form_log_id}}
      <button
        @click="redirect(obj.FormFields[0].form_log_id)"
      >Show Details</button>
    </div>
    <div v-if="form_data">
      <div v-for="(field,fieldKey) in form_data" :key="fieldKey">
        <div v-for="(ffield,ffieldKey) in field" :key="ffieldKey">
          <div>{{ffield.form_field_name}}: {{ffield.field_data=="true"?"YES":ffield.field_data=="undefined"?"NO":ffield.field_data}}</div>
        </div>
      </div>
      
    </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      form_data: [],
      form_input: null,
      input_data: [],
      form_log_id: [],
      form_id: null,
      show_data: []
    };
  },
  mounted() {
    const { form_id } = this.$route.query;
    this.getFormData();
    this.form_id = form_id;
  },
  methods: {
    // setInputs(event, ff_id) {
    //   console.log("event :", event.target.value);
    //   console.log("ff_id :", ff_id);
    // },
    getFormData() {
      const { form_id } = this.$route.query;

      MasterService.GetInputFormData({ form_id: form_id })
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              console.log("data.Records :", data.Records);
              this.show_data = data.Records;
              for (let i in data.Records) {
                this.form_data.push(
                  _.orderBy(data.Records[i].FormFields, "field_id")
                );
                this.form_log_id.push(data.Records[i].form_log_id);
              }
              //   this.form_data = _.orderBy(data.Records, "field_id");
              console.log("this.form_data :", this.form_data);
              console.log("this.form_log_id :", this.form_log_id);
            } else {
              vue.toasted.show(data.message || "Please try later");
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    redirect(log_id) {
      this.$router.push({
        name: "Single Response Form",
        params: { form_id: this.form_id, form_log_id: log_id }
      });
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/FeedbackFormComponents/responseForm.vue